import { Injectable } from '@angular/core';
import { EnrollmentPaymentInfo } from '../models/enrollment-paymentinfo.model';
import { Class } from '../../classes/models/class.model';
import { ExtraService } from '../models/extra-service.model';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentPaymentInfoService {

    constructor() { }

    get(classes: Class[], extras: ExtraService[], totalDiscount: number) {

        let paymentInfo = new EnrollmentPaymentInfo();
            paymentInfo.totalPriceCourses      = classes.reduce((acc, {price}) => acc + price, 0);
            paymentInfo.discountPercentCourses = totalDiscount ? totalDiscount : 0;
            paymentInfo.discountPriceCourses   = Math.round(paymentInfo.totalPriceCourses * (paymentInfo.discountPercentCourses / 100));
            paymentInfo.finalPriceCourses      = paymentInfo.totalPriceCourses - paymentInfo.discountPriceCourses;
            paymentInfo.totalPriceExtras       = extras.reduce((acc, {price}) => acc + price, 0);
            paymentInfo.discountPercentExtras  = 0;
            paymentInfo.discountPriceExtras    = paymentInfo.totalPriceExtras * (paymentInfo.discountPercentExtras / 100);
            paymentInfo.finalPriceExtras       = paymentInfo.totalPriceExtras;
            paymentInfo.finalPriceEnrollment   = paymentInfo.finalPriceCourses + paymentInfo.finalPriceExtras;

        return paymentInfo;

    }

}
